// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cLoye","title":"styles_title__29Lnk"};